import styled, { css } from 'styled-components';

import Button from 'components/button';
import ButtonIcon from 'components/buttonIcon';
import { Flex } from 'components/flex';
import { IconsTypes } from 'components/icons';
import Icons from 'components/icons/Icons';
import Typography from 'components/typography';

interface ListInfoProps {
  list: { icon?: IconsTypes; label?: string; title: string; onClick?: () => void; show?: boolean }[];
  rounded?: boolean;
  withButton?: boolean;
  width?: number | string;
}

const List = styled(Flex)<{ roundedUp?: boolean; roundedDown?: boolean }>`
  display: flex;
  margin-bottom: 1px;

  ${({ roundedUp }) =>
    roundedUp &&
    css`
      border-radius: 4px 4px 0 0;
    `}

  ${({ roundedDown }) =>
    roundedDown &&
    css`
      border-radius: 0 0 4px 4px;
    `}
`;

const Icon = styled(Icons)`
  display: flex;

  ${({ theme: { mediaQueries } }) => {
    return `
      width: 16px;

      ${mediaQueries.desktop} {
        width: 20px;
      }
    `;
  }}
`;

const ListInfo = ({ list, width = 310, withButton = false }: ListInfoProps) => {
  const items = list.filter(({ show }) => {
    return typeof show === 'undefined' || show;
  });

  return (
    <Flex flexGrow={0} width={{ m: '100%', t: width }} mt={{ m: 30, d: 0 }} height={'fit-content'}>
      {items.map(({ icon, label, title, onClick }, index) => (
        <div key={`title-${title}-${index.toString()}`} style={{ width: '100%' }}>
          {!onClick ? (
            <List width={{ m: '100%', t: width }} bg="dark_350" roundedUp={index === 0} roundedDown={!withButton && index === items.length - 1}>
              {icon && (
                <ButtonIcon
                  width={{ m: 60, d: 80 }}
                  height={{ m: 60, d: 80 }}
                  justifyContent="center"
                  icon={icon}
                  size="medium"
                  flexShrink={0}
                  bg="transparent"
                  color="gray_500"
                  title={label}
                />
              )}
              <Flex justifyContent="center" flexDirection="column" pr={{ m: 20, t: 30 }}>
                {label && (
                  <Typography as="h2" type="type0" upper color="gray_500">
                    {label}
                  </Typography>
                )}
                <Typography mt={{ m: 1, d: 2 }} as="h5" type="type2" fontWeight="bold" color="white">
                  {title}
                </Typography>
              </Flex>
            </List>
          ) : (
            <List>
              <Button size="card" onClick={onClick} color="black" square style={{ width: '100%' }}>
                <Flex flexDirection={'row'} justifyContent="space-between" alignItems="center">
                  <span>{title}</span>
                  <Icon icon={'arrowRight'} />
                </Flex>
              </Button>
            </List>
          )}
        </div>
      ))}
    </Flex>
  );
};

export default ListInfo;
